import React, { Component } from "react";
import { CardImg, CardTitle, Button } from "reactstrap";
import { Row, Col } from "antd";
import "./feednews.style.css";
import "../chat/samard.style.css";
import teamwork_samard from "../../assets/feednews/teamwork_samard.png";
import sandeeUpdate from "../../assets/feednews/sandee_ai.png";
import checkMark from "../../assets/feednews/CheckMark.png";
import { pageConfig } from "../configure/page";
import { getText } from "../configure/utils";
import { LanguageContext } from "../../context/LanguageContext";

const SamardCard = () => (
  <div className="newsamardcard2">
  <div className="cardSamard">
    <Button
      className="buttonClass"
      color="none"
      href="https://sandee-samard.scg.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      <Row className="rowSamard">
        <Col
          style={{ alignItems: "center" }}
          xs={{ span: 4 }}
          sm={{ span: 4 }}
          md={{ span: 4 }}
          lg={{ span: 4 }}
          xl={{ span: 6 }}
          xxl={{ span: 6 }}
        >
          <CardImg src={teamwork_samard} className="samardTeamwork" />
        </Col>
        <Col
          xs={{ span: 20 }}
          sm={{ span: 20 }}
          md={{ span: 20 }}
          lg={{ span: 20 }}
          xl={{ span: 18 }}
          xxl={{ span: 18 }}
        >
          <CardTitle className="card-title-samard">
            <div className="samardTitleNameStyle athiti-bold">Samard-Fix Self Service</div>
            <div className="Samard_textStyle">
              <p>{getText("samard.detail")}</p>
            </div>
            <div className="clickHere athiti-bold">{getText("samard.click")}</div>
          </CardTitle>
        </Col>
      </Row>
    </Button>
  </div>
  </div>
);

export default class FeedNews extends Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    this.state = {
      toggleAI: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
      verifyADPass: false,
      preventPaste: false,
    };
    this.menuGenAIClick = this.menuGenAIClick.bind(this);
  }

  menuGenAIClick() {
    this.setState({
      toggleAI: true,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
    });
    const dfMessenger = document.querySelector("df-messenger");
    const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");

    if (dfMessengerBubble) dfMessengerBubble.openChat();

    if (dfMessenger) {
      dfMessenger.startNewSession({ retainHistory: false });

      if (!window.sessionStorage.getItem("dfcx_lang_code")) {
        const start_selectLang = [
          { type: "html", html: "<b style='font-size:21px'>เลือกภาษา (Select Language)</b>" },
        ];
        dfMessenger.renderCustomCard(start_selectLang);

        dfMessenger.renderCustomCard([
          { type: "button", text: "ภาษาไทย", icon: { type: "chevron_right", color: "#FF9800" }, mode: "blocking" },
        ]);
        dfMessenger.renderCustomCard([
          { type: "button", text: "English", icon: { type: "chevron_right", color: "#FF9800" }, mode: "blocking" },
        ]);
      } else {
        window.addEventListener("df-request-sent", (event) => {
          event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
        });
        dfMessenger.sendRequest("event", "greeting");
      }
    }
  }

  render() {
    const { getHowGoodChatWithSandee, getAnnouncement } = pageConfig();
  
    return (
      <div>
        {/* Samard Box */}
        <div className="samard-wrapper">
          <SamardCard />
        </div>
  
        {/* Feed News Box */}
        <div className="cardfeednews">
        <Row className="feedNews athiti-bold">NEWS FEED</Row>
        <Row className="articleStyle">
          <Col lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 4 }}>
            <CardImg src={sandeeUpdate} width={"100%"} className="newUpdate" />
          </Col>
          <Col lg={{ span: 18 }} xl={{ span: 18 }} xxl={{ span: 20 }}>
            <CardTitle className="titleNameStyle athiti-bold">
              <div className="textStyle">
                <p className="blick-button athiti-bold">
                  <b>ASK! SANDEE AI New Feature</b>
                </p>
              </div>
              <p className="newFeatureTextStyle">
                <b>{getText("sandee_helping.head")}</b>
              </p>
              {getText("sandee_helping.content").map((text, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                  <img src={checkMark} alt="checkMark" width={30} />
                  <p className="textStyle">{text}</p>
                </div>
              ))}

              <div className="line"></div>

              <br />

              <p className="newFeatureTextStyle">
                <b>{getText("how_good.head")}</b>
              </p>

              {getHowGoodChatWithSandee().map((item, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                  <img src={item.imgSrc} alt={`icon-${index}`} width={30} />
                  <p className="textStyle">{item.text}</p>
                </div>
              ))}
            </CardTitle>
          </Col>
        </Row>

  
          {getAnnouncement().map((item, index) => (
            <Row key={index} className="articleStyle">
              <Col lg={{ span: 6 }} xl={{ span: 6 }}>
                <CardImg src={item.imageSrc} width={30} className="imageStyle" />
              </Col>
              <Col lg={{ span: 18 }} xl={{ span: 18 }}>
                <CardTitle className="titleNameStyle athiti-bold">
                  {item.title}
                  <p className="textStyle">{item.disscription}</p>
                  <div className="readMore">
                    <a href={item.href} rel="noopener noreferrer" target="_blank">
                      {item.click}
                    </a>
                  </div>
                </CardTitle>
              </Col>
            </Row>
          ))}
        </div>
      </div>
    );
  }
}